import { ShiftsCurrentState } from './index'

const currentShifts = (state: ShiftsCurrentState) => state.currentShifts
const currentShiftsRequest = (state: ShiftsCurrentState) => state.currentShiftsRequest

export default {
  currentShifts,
  currentShiftsRequest,
}
